// extracted by mini-css-extract-plugin
export default {"root":"AttentionMark_root__nAGr6"};